interface ApiError {
	request: XMLHttpRequest;
	response?: Response;
	message: string;
	stack: string;
	code: string;
}

interface Response {
	status: number;
	statusText: string;
	data: any;
	config: any;
	headers: any;
	request: XMLHttpRequest;
}

export function catchError(e: ApiError) {
	if (e.response?.data?.displayableError) {
		// @ts-ignore
		MeddiApp.notification(e.response.data.message);
		// @ts-ignore
	} else if (isNetworkError(e)) {
		// Display error message when user is not connected to the internet
		// @ts-ignore
		MeddiApp.notification(jsTranslation['base.shared.notConnected']);
		// @ts-ignore
	} else if (e.response?.status === 400) {
		if ((e.response?.data?.errors?.length || 0) > 0) {
			e.response?.data?.errors?.forEach((error: { message: string }) => {
				// @ts-ignore
				MeddiApp.notification(error.message);
			});
		}
	} else if (e.code !== 'ECONNABORTED') {
		// @ts-ignore
		MeddiApp.notification(jsTranslation['base.shared.warningBug']);
	}

	return {
		data: { ...e.response?.data, error: true },
		status: e.response?.status,
		statusText: e.response?.statusText,
	};
}

export function isNetworkError(error: ApiError) {
	// @ts-ignore
	const isOnline = window.navigator.onLine;
	// Check if the error message or code suggests a network issue
	const errorMessage = error.message.toLowerCase();
	return (
		!isOnline ||
		errorMessage.includes('network') ||
		errorMessage.includes('internet') ||
		errorMessage.includes('offline') ||
		error.code === 'ERR_INTERNET_DISCONNECTED' ||
		error.code === 'ENOTFOUND'
	);
}
